import React from 'react';

import { LinearProgress } from '@mui/material';

import SafetyEventReportDataGrid from '../../components/safety-event-report/SafetyEventReportDataGrid';
import { EventFormStatus, ReportType } from '../../core/api/clients';
import useGetEventReportsByType from '../../core/api/hooks/event-report/useGetEventReportsByType';

interface ISafetyEventAllSubmissions {
  hours?: number;
  statuses?: EventFormStatus[];
  isOwner?: boolean;
  pageSize?: number;
  readonly?: boolean;
}

function SafetyEventList({ hours = 0, statuses = [], isOwner = false, pageSize = 25, readonly = false }: ISafetyEventAllSubmissions): JSX.Element {
  const reports = useGetEventReportsByType({
    reportType: ReportType.SafetyEventReport,
    hours,
    statuses,
    isOwner,
  });
  if (reports?.isLoading) {
    return (
      <LinearProgress />
    );
  }
  return (
    <SafetyEventReportDataGrid
      data={reports}
      reportType="safety-event"
      areSubmissions
      pageSize={pageSize}
    />
  );
}

export default SafetyEventList;
